import { useNavigate } from "react-router-dom";

const useCustomNavigate = () => {
	const navigate = useNavigate();

	const customNavigate = (path: string) => (e?: any) => {
		navigate(path);
	}

	return { navigate, customNavigate }
}

export { useCustomNavigate }
